import type { useThemeTokens } from "@/lib/theme/tokens";

type Theme = ReturnType<typeof useThemeTokens>;

export function getSidebarLogoutButtonStyles(theme: Theme, isCollapsed: boolean) {
  return {
    color: theme.text.secondary,
    fontWeight: "medium" as const,
    transition: "all 0.18s ease-out",
    sx: {
      "@media (hover: hover)": {
        "&:hover": {
          bg:
            theme.mode === "dark"
              ? "rgba(255,255,255,0.08)"
              : "rgba(11,13,16,0.08)",
          color: "red.400",
          transform: isCollapsed ? "scale(1.05)" : "translateX(2px)",
        },
      },
    },
  };
}
